import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/api';
import { useAuth } from '../context/AuthContext';
import { pdf } from '@react-pdf/renderer';
import ExportPDFEmployerFdwInterview from './ExportPDFEmployerFdwInterview';

// eslint-disable-next-line react/prop-types
const EmployerFdwInterview = ({ booking_id }) => {
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  
  const [formData, setFormData] = useState({
    mode: '',
    fdwName: '',
    nationality: '',
    dob: '',
    age: '',
    passport: '',
    workPlace1: '',
    workYears1: '',
    workEmployers1: '',
    workPlace2: '',
    workYears2: '',
    workEmployers2: '',
    spokenEnglish: '',
    writtenEnglish: '',
    otherLanguage: '',
    otherLangSkill: '',
    alertness: '',
    cooking: '',
    equipment: '',
    domesticKnowledge: '',
    infantCare: '',
    childCare: '',
    elderlyCare: '',
    petCare: '',
    employerName: '',
    employerNric: '',
    employerSignature: '',
    employerDate: '',
    eaName: '',
    eaReg: '',
    eaSignature: ''
  });

  const [result, setResult] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
 const [agencyInfo, setAgencyInfo] = useState({});
  // Fetch existing interview data
  const fetchInterviewData = async () => {
    if (!booking_id) return;
    
    setIsLoading(true);
    try {
      const response = await api.get(`external-forms/employer-fdw-interview/${booking_id}/`);
      if (response.data) {
        setAgencyInfo({
          agencyAddress: response.data.agency_address || '',
          agencyPhone: response.data.agency_phone || ''
        });
        setFormData({
          mode: response.data.mode || '',
          fdwName: response.data.fdw_name || '',
          nationality: response.data.nationality || '',
          dob: response.data.dob || '',
          age: response.data.age || '',
          passport: response.data.passport || '',
          workPlace1: response.data.work_place1 || '',
          workYears1: response.data.work_years1 || '',
          workEmployers1: response.data.work_employers1 || '',
          workPlace2: response.data.work_place2 || '',
          workYears2: response.data.work_years2 || '',
          workEmployers2: response.data.work_employers2 || '',
          spokenEnglish: response.data.spoken_english || '',
          writtenEnglish: response.data.written_english || '',
          otherLanguage: response.data.other_language || '',
          otherLangSkill: response.data.other_lang_skill || '',
          alertness: response.data.alertness || '',
          cooking: response.data.cooking || '',
          equipment: response.data.equipment || '',
          domesticKnowledge: response.data.domestic_knowledge || '',
          infantCare: response.data.infant_care || '',
          childCare: response.data.child_care || '',
          elderlyCare: response.data.elderly_care || '',
          petCare: response.data.pet_care || '',
          employerName: response.data.employer_name || '',
          employerNric: response.data.employer_nric || '',
          employerSignature: response.data.employer_signature || '',
          employerDate: response.data.employer_date || '',
          eaName: response.data.ea_name || '',
          eaReg: response.data.ea_reg || '',
          eaSignature: response.data.ea_signature || ''
        });
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.log('No existing interview found for booking_id:', booking_id);
      } else {
        console.error('Error fetching interview data:', error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchInterviewData();
  }, [booking_id]);

  const validateForm = () => {
    const newErrors = {};
    // All fields are optional
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    setErrors({});
    
    if (!validateForm()) {
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      const apiData = {
        booking: booking_id,
        mode: formData.mode,
        fdw_name: formData.fdwName,
        nationality: formData.nationality,
        dob: formData.dob || null,
        age: formData.age ? parseInt(formData.age) : null,
        passport: formData.passport,
        work_place1: formData.workPlace1,
        work_years1: formData.workYears1,
        work_employers1: formData.workEmployers1,
        work_place2: formData.workPlace2,
        work_years2: formData.workYears2,
        work_employers2: formData.workEmployers2,
        spoken_english: formData.spokenEnglish,
        written_english: formData.writtenEnglish,
        other_language: formData.otherLanguage,
        other_lang_skill: formData.otherLangSkill,
        alertness: formData.alertness,
        cooking: formData.cooking,
        equipment: formData.equipment,
        domestic_knowledge: formData.domesticKnowledge,
        infant_care: formData.infantCare,
        child_care: formData.childCare,
        elderly_care: formData.elderlyCare,
        pet_care: formData.petCare,
        employer_name: formData.employerName,
        employer_nric: formData.employerNric,
        employer_signature: formData.employerSignature,
        employer_date: formData.employerDate || null,
        ea_name: formData.eaName,
        ea_reg: formData.eaReg,
        ea_signature: formData.eaSignature
      };

      const response = await api.post(`external-forms/employer-fdw-interview/${booking_id}/`, apiData);
      console.log('Interview submitted successfully:', response.data);
      alert('Interview form submitted successfully!');
      
    } catch (error) {
      console.error('Error submitting interview:', error);
      if (error.response?.data) {
        if (typeof error.response.data === 'object') {
          setErrors(error.response.data);
        } else {
          alert('Error submitting form: ' + error.response.data);
        }
      } else {
        alert('Error submitting form. Please try again.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const submitForm = () => {
    setResult("Captured JSON: " + JSON.stringify(formData, null, 2));
  };

  const resetForm = () => {
    setFormData({
      mode: '',
      fdwName: '',
      nationality: '',
      dob: '',
      age: '',
      passport: '',
      workPlace1: '',
      workYears1: '',
      workEmployers1: '',
      workPlace2: '',
      workYears2: '',
      workEmployers2: '',
      spokenEnglish: '',
      writtenEnglish: '',
      otherLanguage: '',
      otherLangSkill: '',
      alertness: '',
      cooking: '',
      equipment: '',
      domesticKnowledge: '',
      infantCare: '',
      childCare: '',
      elderlyCare: '',
      petCare: '',
      employerName: '',
      employerNric: '',
      employerSignature: '',
      employerDate: '',
      eaName: '',
      eaReg: '',
      eaSignature: ''
    });
    setResult('');
  };

  const handleDelete = async () => {
    if (!booking_id) {
      alert('No booking ID provided for deletion');
      return;
    }

    const confirmDelete = window.confirm(
      'Are you sure you want to delete this Employer FDW Interview record? This action cannot be undone.'
    );

    if (!confirmDelete) {
      return;
    }

    setIsSubmitting(true);

    try {
      console.log('Deleting Employer FDW Interview for booking_id:', booking_id);
      const response = await api.delete(`external-forms/employer-fdw-interview/${booking_id}/`);
      console.log('Employer FDW Interview deleted successfully:', response.data);
      
      // Show success message
      alert('Employer FDW Interview record deleted successfully!');
      
      // Reset the form after deletion
      resetForm();
      
    } catch (error) {
      console.error('Error deleting Employer FDW Interview:', error);
      alert('Employer FDW Interview record deleted successfully!');
    } finally {
      setIsSubmitting(false);
    }
  };

  const { user } = useAuth();
  const handleDownloadPDF = async () => {
    setIsSubmitting(true);

    try {
      console.log('Generating Employer FDW Interview PDF for booking_id:', booking_id);
      
      // Prepare the data for PDF generation
      const pdfData = {
        ...formData,
        booking_id: booking_id
      };
     
      // Generate PDF using React PDF
      const blob = await pdf(
        <ExportPDFEmployerFdwInterview
          user={user}
          data={pdfData}
          agencyInfo={agencyInfo}
        />
      ).toBlob();
      
      // Create blob link to download
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      
      // Generate filename with current date
      const today = new Date().toISOString().split('T')[0];
      const filename = booking_id 
        ? `Employer_FDW_Interview_${booking_id}_${today}.pdf`
        : `Employer_FDW_Interview_${today}.pdf`;
      link.setAttribute('download', filename);
      
      // Append to html link element page
      document.body.appendChild(link);
      
      // Start download
      link.click();
      
      // Clean up and remove the link
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      console.log('Employer FDW Interview PDF generated and downloaded successfully');
      
    } catch (error) {
      console.error('Error generating PDF:', error);
      alert('Error generating PDF. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="page-wrapper" style={{ marginLeft: '0' }}>
        <div className="content container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="content-page-header">
                    <h5>Employer Personal Interview with FDW</h5>
                  </div>
                  <p className="text-muted small mb-3">Converted from your Word document. (Source: Employer Personal Interview of FDW.docx)</p>

                  {/* Loading Indicator */}
                  {isLoading && (
                    <div className="d-flex justify-content-center align-items-center py-5">
                      <div className="spinner-border text-primary me-3" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <span className="text-muted">Loading existing interview data...</span>
                    </div>
                  )}

                  {/* Form Content - Hidden during loading */}
                  <div style={{ display: isLoading ? 'none' : 'block' }}>
                  <form onSubmit={handleSubmit}>
                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="mb-0">Interview Mode</h6>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          {[
                            { value: 'Telephone', label: 'By Telephone' },
                            { value: 'Video', label: 'Video Conferencing' },
                            { value: 'In person', label: 'In Person' }
                          ].map((mode) => (
                            <div key={mode.value} className="col-lg-4 col-12">
                              <div className="form-check mb-2">
                                <input 
                                  type="checkbox" 
                                  name="mode" 
                                  value={mode.value}
                                  checked={formData.mode.includes(mode.value)}
                                  onChange={handleInputChange}
                                  className="form-check-input"
                                  id={`mode-${mode.value}`}
                                />
                                <label className="form-check-label" htmlFor={`mode-${mode.value}`}>
                                  {mode.label}
                                </label>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="mb-0">FDW Details</h6>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>FDW&apos;s Name</label>
                              <input 
                                type="text" 
                                name="fdwName" 
                                value={formData.fdwName}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Nationality</label>
                              <input 
                                type="text" 
                                name="nationality" 
                                value={formData.nationality}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-4 col-12">
                            <div className="input-block mb-3">
                              <label>Date of Birth</label>
                              <input 
                                type="date" 
                                name="dob" 
                                value={formData.dob}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-12">
                            <div className="input-block mb-3">
                              <label>Age</label>
                              <input 
                                type="number" 
                                name="age" 
                                value={formData.age}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-12">
                            <div className="input-block mb-3">
                              <label>Passport No</label>
                              <input 
                                type="text" 
                                name="passport" 
                                value={formData.passport}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="mb-0">Work Experience</h6>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-lg-4 col-12">
                            <div className="input-block mb-3">
                              <label>Previous Work Place 1</label>
                              <input 
                                type="text" 
                                name="workPlace1" 
                                value={formData.workPlace1}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-12">
                            <div className="input-block mb-3">
                              <label>Years of Experience</label>
                              <input 
                                type="text" 
                                name="workYears1" 
                                value={formData.workYears1}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-12">
                            <div className="input-block mb-3">
                              <label>Number of Employers</label>
                              <input 
                                type="text" 
                                name="workEmployers1" 
                                value={formData.workEmployers1}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-4 col-12">
                            <div className="input-block mb-3">
                              <label>Previous Work Place 2</label>
                              <input 
                                type="text" 
                                name="workPlace2" 
                                value={formData.workPlace2}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-12">
                            <div className="input-block mb-3">
                              <label>Years of Experience</label>
                              <input 
                                type="text" 
                                name="workYears2" 
                                value={formData.workYears2}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-12">
                            <div className="input-block mb-3">
                              <label>Number of Employers</label>
                              <input 
                                type="text" 
                                name="workEmployers2" 
                                value={formData.workEmployers2}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="mb-0">Language Skills</h6>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Spoken English</label>
                              <select 
                                name="spokenEnglish" 
                                value={formData.spokenEnglish}
                                onChange={handleInputChange}
                                className="form-control"
                              >
                                <option value="">Select level</option>
                                <option value="Excellent">Excellent</option>
                                <option value="Good">Good</option>
                                <option value="Fair">Fair</option>
                                <option value="Poor">Poor</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Written English</label>
                              <select 
                                name="writtenEnglish" 
                                value={formData.writtenEnglish}
                                onChange={handleInputChange}
                                className="form-control"
                              >
                                <option value="">Select level</option>
                                <option value="Excellent">Excellent</option>
                                <option value="Good">Good</option>
                                <option value="Fair">Fair</option>
                                <option value="Poor">Poor</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Other Language</label>
                              <input 
                                type="text" 
                                name="otherLanguage" 
                                value={formData.otherLanguage}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Other Language Skill Level</label>
                              <select 
                                name="otherLangSkill" 
                                value={formData.otherLangSkill}
                                onChange={handleInputChange}
                                className="form-control"
                              >
                                <option value="">Select level</option>
                                <option value="Excellent">Excellent</option>
                                <option value="Good">Good</option>
                                <option value="Fair">Fair</option>
                                <option value="Poor">Poor</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="mb-0">Skills Assessment</h6>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Alertness</label>
                              <select 
                                name="alertness" 
                                value={formData.alertness}
                                onChange={handleInputChange}
                                className="form-control"
                              >
                                <option value="">Select rating</option>
                                <option value="Excellent">Excellent</option>
                                <option value="Good">Good</option>
                                <option value="Fair">Fair</option>
                                <option value="Poor">Poor</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Cooking</label>
                              <select 
                                name="cooking" 
                                value={formData.cooking}
                                onChange={handleInputChange}
                                className="form-control"
                              >
                                <option value="">Select rating</option>
                                <option value="Excellent">Excellent</option>
                                <option value="Good">Good</option>
                                <option value="Fair">Fair</option>
                                <option value="Poor">Poor</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Equipment Handling</label>
                              <select 
                                name="equipment" 
                                value={formData.equipment}
                                onChange={handleInputChange}
                                className="form-control"
                              >
                                <option value="">Select rating</option>
                                <option value="Excellent">Excellent</option>
                                <option value="Good">Good</option>
                                <option value="Fair">Fair</option>
                                <option value="Poor">Poor</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Domestic Knowledge</label>
                              <select 
                                name="domesticKnowledge" 
                                value={formData.domesticKnowledge}
                                onChange={handleInputChange}
                                className="form-control"
                              >
                                <option value="">Select rating</option>
                                <option value="Excellent">Excellent</option>
                                <option value="Good">Good</option>
                                <option value="Fair">Fair</option>
                                <option value="Poor">Poor</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="mb-0">Care Skills</h6>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Infant Care</label>
                              <select 
                                name="infantCare" 
                                value={formData.infantCare}
                                onChange={handleInputChange}
                                className="form-control"
                              >
                                <option value="">Select rating</option>
                                <option value="Excellent">Excellent</option>
                                <option value="Good">Good</option>
                                <option value="Fair">Fair</option>
                                <option value="Poor">Poor</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Child Care</label>
                              <select 
                                name="childCare" 
                                value={formData.childCare}
                                onChange={handleInputChange}
                                className="form-control"
                              >
                                <option value="">Select rating</option>
                                <option value="Excellent">Excellent</option>
                                <option value="Good">Good</option>
                                <option value="Fair">Fair</option>
                                <option value="Poor">Poor</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Elderly Care</label>
                              <select 
                                name="elderlyCare" 
                                value={formData.elderlyCare}
                                onChange={handleInputChange}
                                className="form-control"
                              >
                                <option value="">Select rating</option>
                                <option value="Excellent">Excellent</option>
                                <option value="Good">Good</option>
                                <option value="Fair">Fair</option>
                                <option value="Poor">Poor</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Pet Care</label>
                              <select 
                                name="petCare" 
                                value={formData.petCare}
                                onChange={handleInputChange}
                                className="form-control"
                              >
                                <option value="">Select rating</option>
                                <option value="Excellent">Excellent</option>
                                <option value="Good">Good</option>
                                <option value="Fair">Fair</option>
                                <option value="Poor">Poor</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="mb-0">Signatures</h6>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Employer Name</label>
                              <input 
                                type="text" 
                                name="employerName" 
                                value={formData.employerName}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Employer NRIC</label>
                              <input 
                                type="text" 
                                name="employerNric" 
                                value={formData.employerNric}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Employer Signature</label>
                              <input 
                                type="text" 
                                name="employerSignature" 
                                value={formData.employerSignature}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Date</label>
                              <input 
                                type="date" 
                                name="employerDate" 
                                value={formData.employerDate}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-4 col-12">
                            <div className="input-block mb-3">
                              <label>EA Personnel Name</label>
                              <input 
                                type="text" 
                                name="eaName" 
                                value={formData.eaName}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-12">
                            <div className="input-block mb-3">
                              <label>EA Registration No</label>
                              <input 
                                type="text" 
                                name="eaReg" 
                                value={formData.eaReg}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-12">
                            <div className="input-block mb-3">
                              <label>EA Personnel Signature</label>
                              <input 
                                type="text" 
                                name="eaSignature"
                                value={formData.eaSignature}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <div className="btn-path text-end">
                          <button type="button" className="btn btn-cancel bg-primary-light me-3" onClick={resetForm} disabled={isSubmitting}>
                            Reset
                          </button>
                          <button
                            type="button"
                            onClick={handleDelete}
                            className="btn btn-danger me-3"
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? 'Deleting...' : 'Clean'}
                          </button>
                          <button
                            type="button"
                            onClick={handleDownloadPDF}
                            className="btn btn-success me-3"
                            disabled={isSubmitting}
                            title="Download PDF of current form data"
                          >
                            {isSubmitting ? 'Generating...' : (
                              <>
                                <i className="fas fa-download me-2"></i>
                                Download PDF
                              </>
                            )}
                          </button>
                          <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                            {isSubmitting ? 'Submitting...' : 'Submit'}
                          </button>
                        </div>
                      </div>
                    </div>
                    {errors.general && (
                      <div className="alert alert-danger mt-3">{errors.general}</div>
                    )}
                  </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployerFdwInterview;
